var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDiners(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 780,
    height: 500,
    enableBackground: "new 0 0 780 500",
    viewBox: "0 0 780 500",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m0 42.426c0-23.432 18.571-42.426 41.458-42.426h694.58c22.897 0 41.459 18.99 41.459 42.426v414.65c0 23.432-18.571 42.426-41.459 42.426h-694.58c-22.896 0-41.458-18.989-41.458-42.426v-414.65zm606.38 208.86c0-105.43-86.022-178.31-180.27-178.27h-81.11c-95.376-0.035-173.88 72.862-173.88 178.27 0 96.432 78.504 175.66 173.88 175.2h81.111c94.247 0.462 180.27-78.789 180.27-175.2zm-261-163.66c-87.153 0.028-157.77 72.441-157.8 161.81 0.021 89.356 70.642 161.76 157.8 161.79 87.173-0.027 157.81-72.434 157.82-161.79-0.014-89.371-70.648-161.78-157.82-161.81zm-100.02 161.81c0.082-43.672 26.69-80.913 64.211-95.711v191.4c-37.52-14.791-64.13-52.01-64.211-95.689zm135.82 95.733v-191.45c37.534 14.763 64.185 52.024 64.252 95.718-0.067 43.707-26.718 80.941-64.252 95.732v2e-3z",
    fill: "#ECECEC"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiners);
export default __webpack_public_path__ + "static/media/diners.51bc495816a0658d579eea167e4a6a07.svg";
export { ForwardRef as ReactComponent };